"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BabylonCanvas = void 0;
const core_1 = require("@babylonjs/core");
const GUI = __importStar(require("@babylonjs/gui"));
require("@babylonjs/loaders/glTF");
class BabylonCanvas {
    setCamera(camera) {
        this.scene.activeCamera = camera;
        console.log("setting active cam");
    }
    getScale(mesh, multiplier) {
        const boundingInfo = mesh.getHierarchyBoundingVectors(true);
        const currentLength = boundingInfo.max.subtract(boundingInfo.min);
        const biggestSide = Math.max(currentLength.x, Math.max(currentLength.y, currentLength.z));
        return multiplier / biggestSide;
    }
    loadWebXR() {
        return __awaiter(this, void 0, void 0, function* () {
            const xr = yield this.scene.createDefaultXRExperienceAsync({
                uiOptions: {
                    sessionMode: "immersive-ar",
                    referenceSpaceType: "local-floor",
                },
                optionalFeatures: true,
            });
            const featureManager = xr.baseExperience.featuresManager;
            const xrHitTest = featureManager.enableFeature(core_1.WebXRHitTest, "latest");
            const anchors = featureManager.enableFeature(core_1.WebXRAnchorSystem, "latest");
            const backgroundRemover = featureManager.enableFeature(core_1.WebXRBackgroundRemover.Name);
            const marker = core_1.MeshBuilder.CreateTorus("marker", {
                diameter: 0.15,
                thickness: 0.05,
            });
            marker.isVisible = false;
            marker.rotationQuaternion = new core_1.Quaternion();
            xrHitTest.onHitTestResultObservable.add((results) => {
                if (results.length) {
                    this.hitTestResult = results[0];
                    marker.isVisible = true;
                    if (marker.rotationQuaternion) {
                        this.hitTestResult.transformationMatrix.decompose(marker.scaling, marker.rotationQuaternion, marker.position);
                    }
                }
                else {
                    this.hitTestResult = null;
                    marker.isVisible = false;
                }
            });
            if (anchors) {
                anchors.onAnchorAddedObservable.add((anchor) => {
                    console.log("onAnchorAddedObservable");
                    if (this.model) {
                        console.log("cloning");
                        this.model.setEnabled(true);
                        console.log("setting scale");
                        const clone = this.model.clone("clone", null, false);
                        if (clone) {
                            anchor.attachedNode = clone;
                        }
                        this.model.setEnabled(false);
                    }
                });
                const scaleValue = this.options.scaleWebXR;
                anchors.onAnchorUpdatedObservable.add((anchor) => {
                    if (anchor && anchor.attachedNode) {
                        anchor.attachedNode.scaling.setAll(scaleValue);
                        /*
                        console.log('onAnchorUpdatedObservable');
                        const desiredSizeInMeters = 0.5;
                        const boundingBox = (anchor.attachedNode as AbstractMesh).getBoundingInfo().boundingBox;
                        console.log(boundingBox);
                        const currentSize = boundingBox.maximum.subtract(boundingBox.minimum).length();
                        console.log(currentSize);
                        const scaleRatio = desiredSizeInMeters / currentSize;
                        console.log(scaleRatio);
                        anchor.attachedNode.scaling = new Vector3(scaleRatio, scaleRatio, scaleRatio);
                         */
                    }
                });
                anchors.onAnchorRemovedObservable.add((anchor) => {
                    var _a, _b;
                    if (anchor) {
                        (_a = anchor.attachedNode) === null || _a === void 0 ? void 0 : _a.setEnabled(false);
                        (_b = anchor.attachedNode) === null || _b === void 0 ? void 0 : _b.dispose();
                    }
                });
            }
            const createButton = () => {
                const placeBtn = GUI.Button.CreateSimpleButton("placeBtn", "Model platzieren");
                placeBtn.width = "30%";
                placeBtn.height = "10%";
                placeBtn.color = "white";
                placeBtn.cornerRadius = 20;
                placeBtn.background = "green";
                placeBtn.top = "40%";
                return placeBtn;
            };
            xr.baseExperience.sessionManager.onXRSessionInit.add(() => {
                console.log("session init");
                console.log(this.model);
                if (this.model) {
                    this.model.setEnabled(false);
                }
            });
            xr.baseExperience.sessionManager.onXRFrameObservable.addOnce(() => {
                console.log("onXRFrameObservable");
                console.log("creating button");
                const placeButton = createButton();
                const advancedTexture = GUI.AdvancedDynamicTexture.CreateFullscreenUI("UI");
                advancedTexture.addControl(placeButton);
                placeButton.onPointerUpObservable.add(() => {
                    console.log("onPointerUpObservable");
                    if (this.hitTestResult &&
                        anchors &&
                        xr.baseExperience.state === core_1.WebXRState.IN_XR) {
                        console.log("hitresult && anchors && state");
                        const matrix = this.hitTestResult.transformationMatrix;
                        const localPosition = new core_1.Vector3();
                        const transformCoordinates = core_1.Vector3.TransformCoordinates(localPosition, matrix);
                        const rotation = new core_1.Quaternion();
                        anchors.addAnchorAtPositionAndRotationAsync(transformCoordinates, rotation);
                    }
                });
                if (this.scene.activeCamera) {
                    xr.baseExperience.camera.position.copyFrom(new core_1.Vector3(this.options.cameraAlpha, this.options.cameraBeta, this.options.cameraRadius));
                }
                xr.baseExperience.camera.target = new core_1.Vector3(this.options.cameraVectorX, this.options.cameraVectorY, this.options.cameraVectorZ);
            });
            return xr;
        });
    }
    startARKit() {
        const linkElement = document.createElement("a");
        linkElement.setAttribute("rel", "ar");
        const image = document.createElement("img");
        image.setAttribute("src", "ar-prototype/assets/img.png");
        linkElement.appendChild(image);
        linkElement.setAttribute("href", this.options.rootUrl.concat(this.options.usdFileName));
        document.body.appendChild(linkElement);
        linkElement.click();
    }
    // Function to create and show the speech bubble
    createSpeechBubble(text, mesh, event) {
        if (!this.advancedTexture) {
            this.advancedTexture =
                GUI.AdvancedDynamicTexture.CreateFullscreenUI("UI");
        }
        // Create a rectangle for the background of the speech bubble
        const rect = new GUI.Rectangle();
        rect.background = "black";
        rect.alpha = 0.7;
        rect.cornerRadius = 0;
        rect.thickness = 0;
        rect.width = "300px";
        rect.height = "250px";
        const closeButton = GUI.Button.CreateImageOnlyButton("closeButton", "/ar-prototype/assets/close_icon.png");
        closeButton.width = "16px";
        closeButton.height = "16px";
        closeButton.top = "15px";
        closeButton.left = "-15px";
        closeButton.thickness = 0;
        closeButton.horizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_RIGHT;
        closeButton.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_TOP;
        closeButton.onPointerUpObservable.add(() => {
            this.removeSpeechBubble();
        });
        rect.addControl(closeButton);
        // Create a text block to display the text in the speech bubble
        const textBlock = new GUI.TextBlock();
        textBlock.text = text;
        textBlock.resizeToFit = true;
        textBlock.textWrapping = true;
        textBlock.color = "white";
        textBlock.fontSize = 14;
        textBlock.textHorizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_LEFT;
        textBlock.paddingLeft = "10px";
        const scrollViewer = new GUI.ScrollViewer();
        scrollViewer.height = "210px";
        scrollViewer.horizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_LEFT;
        scrollViewer.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_BOTTOM;
        scrollViewer.addControl(textBlock);
        // Add the text block to the rectangle
        rect.addControl(scrollViewer);
        // Calculate position based on event's clientX and clientY
        rect.linkOffsetXInPixels = 250;
        rect.linkOffsetYInPixels = 50;
        // Add the rectangle to the advanced texture
        this.advancedTexture.addControl(rect);
        rect.linkWithMesh(mesh);
        // Store references to the text block and rectangle for later removal
        this.textBlock = textBlock;
    }
    // Function to remove the speech bubble
    removeSpeechBubble() {
        if (this.advancedTexture) {
            this.advancedTexture.dispose();
            this.advancedTexture = null;
            this.textBlock = null;
        }
    }
    constructor(options) {
        this.options = options;
        // Define variables for the outline and the currently selected mesh
        this.outline = null;
        this.hitTestResult = null;
        this.selectedMesh = null;
        this.model = null;
        // Define variables for the GUI text block and the advanced texture
        this.advancedTexture = null;
        this.textBlock = null;
        this.scaleCanvas(options.htmlElement);
        // Babylon.js Scene Setup
        const engine = new core_1.Engine(options.htmlElement, true);
        this.scene = new core_1.Scene(engine);
        this.scene.clearColor = new core_1.Color4(1, 1, 1, 1);
        this.scene.createDefaultEnvironment({
            enableGroundMirror: false,
            groundShadowLevel: 0.6,
            groundOpacity: 0,
            createSkybox: false,
        });
        // layer used for selection of meshes
        const highlightLayer = new core_1.HighlightLayer("outlining", this.scene);
        // Camera and Lights
        var arcRotateCamera = new core_1.ArcRotateCamera("Freie Kamera", options.cameraAlpha, options.cameraBeta, options.cameraRadius, new core_1.Vector3(options.cameraVectorX, options.cameraVectorY, options.cameraVectorZ), this.scene);
        console.log("Freie Kamera", options.cameraAlpha, options.cameraBeta, options.cameraRadius, options.cameraVectorX, options.cameraVectorY, options.cameraVectorZ);
        arcRotateCamera.inputs.remove(arcRotateCamera.inputs.attached.mousewheel);
        arcRotateCamera.attachControl(options.htmlElement, true);
        this.setCamera(arcRotateCamera);
        // Load the GLTF Model
        core_1.SceneLoader.ImportMesh("", options.rootUrl, options.sceneFileName, this.scene, (meshes) => {
            var _a;
            options.onCamerasReady &&
                options.onCamerasReady.call(null, (_a = this.scene.cameras) !== null && _a !== void 0 ? _a : []);
            const material = new core_1.PBRMaterial("sphereMtl", this.scene);
            const texture = core_1.CubeTexture.CreateFromPrefilteredData("/ar-prototype/assets/Studio_Softbox_2Umbrellas_cube_specular.dds", this.scene);
            material.reflectionTexture = texture;
            texture.gammaSpace = false;
            this.scene.environmentTexture = texture;
            if (options.preferredCameraId && this.scene.cameras.length) {
                const preferredCamera = this.scene.cameras.find((c) => c.id === options.preferredCameraId);
            }
            this.model = meshes[0];
        }, this.options.onLoading);
        // Render Loop
        engine.runRenderLoop(() => {
            this.scene.render();
        });
        // Handle Window Resizing
        window.addEventListener("resize", function () {
            engine.resize();
        });
        // Handle Mouse Clicks
        this.scene.onPointerDown = (event, pickInfo) => {
            var _a;
            console.log("onPointerDown");
            const hasDescription = pickInfo.pickedMesh !== null &&
                options.descriptions.has(pickInfo.pickedMesh.id);
            if (options.withTransparency) {
                this.scene.meshes.forEach((mesh) => {
                    mesh.visibility = 1;
                });
            }
            if (this.hitTestResult && options.rootUrl && options.usdFileName) {
                // Load and place the 3D model at the hit test result position
                console.log("importing mesh in onPointerDown");
            }
            options.onDescriptedMeshSelected &&
                options.onDescriptedMeshSelected(undefined);
            if (options.onClick && pickInfo.pickedMesh) {
                options.onClick(pickInfo.pickedMesh.id, event.clientX, event.clientY);
                // Remove any existing speech bubble
                this.removeSpeechBubble();
                if (pickInfo.pickedMesh.id && hasDescription) {
                    const description = (_a = options.descriptions.get(pickInfo.pickedMesh.id)) !== null && _a !== void 0 ? _a : "n/a";
                    options.onDescriptedMeshSelected &&
                        options.onDescriptedMeshSelected.call(null, description);
                    // Create and display the speech bubble
                    /*
                    this.createSpeechBubble(
                      description,
                      pickInfo.pickedMesh,
                      event
                    );
                     */
                }
            }
            // reset the renderOutline
            this.scene.meshes.forEach((m) => {
                highlightLayer.removeMesh(m);
            });
            if (pickInfo.hit) {
                if (pickInfo.pickedMesh && hasDescription) {
                    // Ein neues Mesh wurde ausgewählt; speichere es und zeige die Outline an
                    this.selectedMesh = pickInfo.pickedMesh;
                    highlightLayer.addMesh(this.selectedMesh, new core_1.Color3(0, 0, 1));
                    if (options.withTransparency) {
                        // Setze die Transparenz des restlichen 3D-Modells auf 60%
                        this.scene.meshes
                            .filter((m) => m !== this.selectedMesh)
                            .forEach((mesh) => {
                            mesh.visibility = 0.3;
                        });
                    }
                }
                else {
                    this.selectedMesh = null;
                }
            }
        };
    }
    scaleCanvas(canvasElement) {
        canvasElement.style.width = "100%";
        canvasElement.style.height = "500px";
    }
}
exports.BabylonCanvas = BabylonCanvas;
